// modules
import React, { FC, useCallback } from 'react';
import { AddIcon, Button, View } from '@upstox/upstox-ui';
import { observer } from 'mobx-react';
// modules
import LocaleService from 'modules/Localization';
import PriceAlerts from 'modules/PriceAlerts';
import SearchService from 'modules/Search';
import { useStore } from 'modules/Stores';
// components
import PriceAlertsLoadingFooter from 'modules/PriceAlerts/components/PriceAlertsLoadingState/PriceAlertsLoadingFooter';
// styles
import * as css from './styles';

const PriceAlertsListFooter: FC = () => {
  const { setModalType, setScripData } = useStore('PriceAlertsStore');
  const {
    chartSymbol,
  } = useStore('TradingChartStore');

  const { getLoading } = useStore('LoadingStore');
  const { getError } = useStore('ErrorStore');
  const isLoading = getLoading('PRICE_ALERT');
  const isError = getError('PRICE_ALERT');

  const handleCreateAlertClick = useCallback(async () => {
    const data = await SearchService.searchByExchangeToken(chartSymbol);
    setScripData(data);
    setModalType('Create');
  }, [setModalType, setScripData, chartSymbol]);

  if (isLoading) {
    return <PriceAlertsLoadingFooter />;
  }

  return (
    <View css={css.container}>
      {isError
        ? (
          <Button css={css.button} onClick={PriceAlerts.getPriceAlerts}>
            {LocaleService.translate('TRY_AGAIN')}
          </Button>
        )
        : (
          <Button css={css.button} onClick={handleCreateAlertClick}>
            <AddIcon css={css.icon} />{' '}
            {LocaleService.translate('CREATE_ALERT_BUTTON')}
          </Button>
        )}
    </View>
  );
};

export default observer(PriceAlertsListFooter);
